import React from "react";

const GoalsOverviewBox = ({ title, headings, onGoalClick }) => {
  const handleGoalClick = (heading) => {
    if (onGoalClick) {
      onGoalClick(heading);
    }
  };

  return (
    <div className="goals-overview-cards">
      <h3
        className="text-heading-h3 text-center"
        style={{ marginBottom: "20px", color: "#ffffff" }}
      >
        {title}
      </h3>
      <div className="d-flex flex-column gap-3">
        {headings.map((heading, index) => (
          <div
            key={index}
            className={`goals-overview-small-cards body-b5 ${
              heading.selected ? "selected" : ""
            }`}
            style={{
              color: "#e6ecf1",
              cursor: "pointer",
            }}
            title={heading.title}
            onClick={() => handleGoalClick(heading)}
          >
            <span
              style={{
                display: "inline-block",
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                verticalAlign: "middle",
              }}
            >
              {heading.title.charAt(0).toUpperCase() + heading.title.slice(1)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalsOverviewBox;
